import axios from 'axios';
import {getApiDomain} from '../util/domains';

const $http = axios.create({});

const api_domain = getApiDomain();

$http.interceptors.request.use(req => {
    req.url = api_domain + req.url;

    let no_auth_routes = [
        'api/login',
        'api/login-wms',
        'contrasena/olvido',
        'contrasena/buscar',
        'contrasena/restablecer',
        'api/app-image-product',
        'app/login'
    ];

    let user = JSON.parse(localStorage.getItem('user')) || [];
    let no_auth_route = no_auth_routes.find(nar => req.url.includes(nar));

    if (!no_auth_route) {
        if (user && user.token) {
            req.headers.Authorization = `Bearer ${user.token}`;
        } else {
            return Promise.reject(new Error('No hay usuario autenticado'));
        }
    }

    return req;

}, error => {
    console.log(`interceptor request ${error}`);
});

$http.interceptors.response.use(resp => {
    const headers = resp.headers;

    if (headers['x-additional-data']) {
        let subscriber = atob(headers['x-additional-data']);
        localStorage.setItem('subscriber_for_collection', subscriber);
    }

    return resp;
}, error => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest.url.includes('validar-contrasena')) {
        localStorage.clear();
        window.location.href = '/#/login';
        window.location.reload();
    }

    return Promise.reject(error);
});


export default $http;



// WEBPACK FOOTER //
// ./src/axios/index.js